import qccapis  from "../../api/qcc";
import apis from "../../api/index";
import flowapis  from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";

export default {
    name: "BankAudit",
    props: {
      visible: {
          type: Boolean, 
          require: false 
      },
      propsOne: String
    },
    data() {
        return {
            query: {
                userName: "",
            },
            isVisible:this.visible,
            detailResult:{},
            caseResult:["","","",""],
            llTableData:[],
            cllTableData:[],
            llListResult:[],
            llShow:false,
            cllShow:false,
            llquery:false,
            companyShow:true,
            credit:{num:"暂无",comment:"暂无"},
            flowInfo:{},
            fileList:[],
            picList:[],
            reasonVisible:false,
            queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if(meta&&meta.permBtns.length>0){
          this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      onChangeClose(){
        this.isVisible = false
      },
      onChangeOpen(){
        this.isVisible = true
      },
      queryClick(flag){
        var data={};
        var that=this;
        if(flag==1){
          if(this.idCard==""){
            this.$message.error("身份证为空，建议查询时输入哦");return;
          }
          if(this.llTableData.length>0){
              this.llShow=!this.llShow;this.cllShow=false;
              if(this.llquery)return
              else this.llquery=true;
              data=this.llTableData[0];
          }else{
              return
          }
          let param = {
            id:data.Id
          }
          qccapis.getLLDetail(param).then(res => {
              if(res!=null){
                if(Number(res.Status)==200){
                that.llListResult = res.Result.Data;
              }else{
                that.$message.error(res.Message)
              }
              }else{
                that.$message.error("查询老赖失信列表信息失败")
            }
          });
        }else{
          if(that.caseResult.SXCount==0){
            return;
          }
          this.cllShow=!this.cllShow;
          this.llShow=false;
          if(this.cllquery){
            return
          }else {
            this.cllquery=true;
          }
          data=this.cllTableData[0];
          let param = {
                idCard:this.detailResult.Name,
                type:1
          }
          qccapis.getLL(param).then(res => {
            if(res!=null){
              if(Number(res.Status)==200){
                that.data2Show=true;
                var cllTableData = res.Result.Data;
                if(cllTableData){
                  that.cllTableData=cllTableData;
                  if(cllTableData.length==0){
                    return
                  }
                  let param = {
                      id:cllTableData[0].Id
                  }
                  qccapis.getLLDetail(param).then(res => {
                      if(res!=null){
                        if(Number(res.Status)==200){
                          that.cllListResult = res.Result.Data;
                        }else{
                          that.$message.error(res.Message)
                        }
                      }else{
                        that.$message.error("查询老赖失信列表信息失败")
                      }
                  });
                }
              }else{
                that.cllTableData = [];
                that.$message.error(res.Message)
              }
            }else{
              that.cllTableData = [];
              that.$message.error("查询老赖信息失败")
            }
          });    
        }
      },
      queryData(row){
        let that = this
        that.fileList = []
        that.picList = []
        if(row){
          that.flowInfo = row
          // 查询营业执照
          const yyzz = qccapis.getCPDetail({id:row.Code})
          // 诉讼信息
          const ssxx = qccapis.getCPCase({id:row.Code})
          // 查询老赖信息
          const llxx = qccapis.getLL({idCard:row.idCard})
          // 查询老赖信息
          const llxx2 = qccapis.getCredit({idCard:row.idCard,code:row.Code})

          // // 查询政务信息
          // const promise3 = 

          Promise.all([yyzz, ssxx , llxx,llxx2]).then((res) => {
            if(res.length===4){
              if(res[0]&&res[0]['Result']){
                that.detailResult = res[0]['Result']
              }else{
                that.detailResult = {}
              }
              if(res[1]['Result']&&res[1]['Result']['Data']){
                that.caseResult = res[1]['Result']['Data']
              }else{
                that.caseResult = {}
              }
              if(res[2]['Result']&&res[2]['Result']['Data']){
                  let llTableData = res[2]['Result']['Data']
                  let list = []
                  for(let i=0;i<llTableData.length;i++){
                    let cerNo=llTableData[i].CerNo.replace('<em>', '')
                    llTableData[i].CerNo=cerNo.replace('</em>', '')
                    if(llTableData[i].Name === this.keyword || llTableData[i].Name === that.flowInfo.Name){
                      list.push(llTableData[i])
                    }
                  }
                  that.llTableData=list
              }else{
                that.llTableData = []
              }
              if(res[3]['Result']){
                  that.credit = res[3]['Result'];
              }
            }
          })
          if(!row.Code){
            that.companyShow=false;
          }
        }
      },
      beforeAvatarPicUpload(file) {
          let that = this
          const isJPG = 
              file.type ==="image/jpg"||
              file.type ==="image/jpeg"||
              file.type ==="image/png"
          const isLt2M = file.size/1024/1024 <2
          if(!isJPG){
              that.$message.error("仅支持jpg、png格式的图片")
          }
          if(!isLt2M){
              that.$message.error("上传图片大小不能超过2MB") 
          }
          return isJPG && isLt2M
      },
      uploadPicFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.picList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      beforeAvatarFileUpload(file) {
        let that = this
        const isLt2M = file.size/1024/1024 <10
        if(!isLt2M){
            that.$message.error("上传文件大小不能超过10MB") 
        }
        return true
      },
      uploadFileFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          apis.uploadFile(form).then(res => {
              that.fileList.push({
                name: that.getFileName(res.fullPath),
                url:res.fullPath
              })
          });
      },
      getFileName(path){
        var pos1 = path.lastIndexOf('/');
        var pos2 = path.lastIndexOf('\\');
        var pos  = Math.max(pos1, pos2)
        if( pos<0 )
            return path;
        else
            return path.substring(pos+1);
      },
      handlePicRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.picList.length;i++){
            if(file.url===that.picList[i].url){
              that.picList.splice(i,1)
            }
          }
        }
      },
      handleFileRemove(file) {
        let that = this
        if(file){
          for(let i=0;i<that.fileList.length;i++){
            if(file.url===that.fileList[i].url){
              that.fileList.splice(i,1)
            }
          }
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePicDownload(file) {
        if(file){
          fetch(file.url,{
            mode: 'cors',
          })
          .then((response) => response.blob())
          .then((res) => {
            const blob = new Blob([res])
            const elink = document.createElement('a')
            elink.download = file.name
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          });
        }
      },


      /**
       * 银行拒绝通过
       */
      onReturnFlow(){
        let that = this
        this.$prompt('', '必须填写拒绝的原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '必须填写原因',
          inputValidator:(value)=>{
            if(value.trim().length<1){
              return false
            }
          },
          beforeClose: (action, instance, done)=>{
            if(action == 'confirm'){
                let value = instance.inputValue
                if(value && value != ''){
                  let param = {
                    Id:that.flowInfo.Id,
                    Route:3,
                    RefuseReason:value,
                    BankID:that.flowInfo.BankID,
                    State:'4',
                    RefuseType:'1'
                  }
                  let fileParams = []
                  for(let i=0;i<that.fileList.length;i++){
                      let fileItem = {
                        ProcessId:that.flowInfo.Id,
                        Type:'2',
                        Url:that.fileList[i]['url'],
                        Name:that.fileList[i]['name']
                      }
                      fileParams.push(fileItem)
                  }
                  for(let i=0;i<that.picList.length;i++){
                      let fileItem = {
                        ProcessId:that.flowInfo.Id,
                        Type:'1',
                        Url:that.picList[i]['url'],
                        Name:that.picList[i]['name']
                      }
                      fileParams.push(fileItem)
                  }

                  if(fileParams.length>0){
                    param['fileList'] = fileParams
                  }
                  flowapis.updateFlow(param).then((res) => {
                    if(res&&res.code){
                      done()
                    }else{
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    }
                  })
                }
            }else{
              done()
            }
          }
        }).then(({ value }) => {
            // that.$emit('bankauditsucess');
            that.onChangeClose()
            this.$parent.bankAuditSucess()
        }).catch(() => {
               
        });
      },
      /**
       * 银行通过
       */
      onPassFlow(){
        let that = this
        let param = {
          Id:that.flowInfo.Id,
          Route:3,
          BankID:that.flowInfo.BankID
        }
        let fileParams = []
        for(let i=0;i<that.fileList.length;i++){
            let fileItem = {
              ProcessId:that.flowInfo.Id,
              Url:that.fileList[i]['url'],
              Type:2,
              Name:that.fileList[i]['name']
            }
            fileParams.push(fileItem)
        }
        for(let i=0;i<that.picList.length;i++){
            let fileItem = {
              ProcessId:that.flowInfo.Id,
              Url:that.picList[i]['url'],
              Type:1,
              Name:that.picList[i]['name']
            }
            fileParams.push(fileItem)
        }
        if(fileParams.length>0){
          param['fileList'] = fileParams
        }
        flowapis.updateFlow(param).then((res) => {
          if(res&&res.code){
            // that.$emit('bankauditsucess');
            that.onChangeClose()
            this.$parent.bankAuditSucess()
          }else{
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
      }
    },
  };
